import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/components/App';
import reportWebVitals from './components/reportWebVitals';
import ScrollToTop from "./components/helpers/ScrollToTop";
import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop />
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
